import MarkdownEditor from "../MarkdownEditor";

type NoteEditorPanelProps = {
  contentLoading: boolean;
  activeTitle: string | null;
  activeContent: string;
  emptyMessage: string;
  placeholder: string;
  charCountSuffix?: string;
  onChangeContent: (value: string) => void;
};

export default function NoteEditorPanel({
  contentLoading,
  activeTitle,
  activeContent,
  emptyMessage,
  placeholder,
  charCountSuffix = "자",
  onChangeContent,
}: NoteEditorPanelProps) {
  if (contentLoading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-6 w-6 border-2 border-indigo-500 border-t-transparent" />
      </div>
    );
  }
  if (!activeTitle) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm flex items-center justify-center h-64">
        <p className="text-sm text-gray-400">{emptyMessage}</p>
      </div>
    );
  }
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-700">
          {activeTitle}
        </span>
        <span className="text-xs text-gray-400">
          {activeContent.length}
          {charCountSuffix}
        </span>
      </div>
      <MarkdownEditor
        value={activeContent}
        onChange={onChangeContent}
        placeholder={placeholder}
      />
    </div>
  );
}
